import { Component } from '@angular/core';
// OWN
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { InputFileComponent } from '../../components/input-file/input-file.component';
import { StageTableComponent } from '../../components/stage-table/stage-table.component';
import { TranslateModule } from '@ngx-translate/core';

// BACKEND
import {
  AccountPostReceiptDto,
  AccountReceiptClient,
  AccountReceiptDto,
  FileParameter,
  GetAccountReceiptsOfTodayQuery,
  IAccountPostReceiptDto,
  IAccountReceiptDto,
} from '@tech/api-clients/receipts';
import { PrettyConsole } from '@app/shared/utils';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { PermanentTableComponent } from '../../components/permanent-table/permanent-table.component';
import {
  IFilters,
  PermanentTablePaginatedComponent,
} from '../../components/permanent-table-paginated/permanent-table-paginated.component';
import { ReceiptComponent } from '../../components/receipt/receipt.component';
import { FileProcessorService } from '@app/shared/services/wasm/file-processor/file-processor.service';
import { NotificationService } from '@app/shared/services/notification/notification.service';
import { NotificationhubService } from '@app/shared/services/notificationhub/notificationhub.service';

interface ReceiptDisplay extends IAccountPostReceiptDto {
  ok: boolean;
  [key: string]: string | number | boolean | Date | undefined;
}

@Component({
  selector: 'app-receipt-account',
  standalone: true,
  imports: [
    NavbarComponent,
    InputFileComponent,
    StageTableComponent,
    ReceiptComponent,
    TranslateModule,
  ],
  templateUrl: './receipt-account.component.html',
  styleUrl: './receipt-account.component.scss',
})
export class ReceiptAccountComponent extends ReceiptComponent {
  displayedColumns: string[] = Object.keys(
    AccountPostReceiptDto.prototype.toJSON()
  ).map((c) => c.toLowerCase());
  stagedReceipts: ReceiptDisplay[] = [];
  available_f: IFilters[] = [];
  override sse_name: string = 'AccountReceipt';

  validation_s = {};

  client_proc = (files: FileParameter[]) => {
    return this.child_client.uploadAccountFiles(files);
  };

  constructor(
    dialog: MatDialog,
    fileProcessor: FileProcessorService,
    notify: NotificationService,
    hub: NotificationhubService,
    private child_client: AccountReceiptClient
  ) {
    super(dialog, fileProcessor, notify, hub);
    this.sse_name = 'AccountReceipt';
    this.upload_handler = this.client_proc.bind(this);
    if (this.available_f.length === 0) {
      this.child_client.getFilterStructure(undefined).subscribe({
        next: (d) => {
          var parsed = JSON.parse(d);
          this.available_f = parsed;
        },
      });
    }
  }

  search_through_receipts = () => {
    this.dialog.closeAll();
    const data_source = new PermanentAccountReceipts();
    this.dialog.open(PermanentTablePaginatedComponent<IAccountReceiptDto>, {
      width: '100vw',
      maxWidth: '98vw',
      height: '95vh',
      data: {
        receipts: data_source,
        display: Object.keys(AccountReceiptDto.prototype.toJSON()).filter(
          (d) => d !== 'id'
        ),
        callback: this.get_paginated_data,
        filters: this.available_f,
      },
    });
  };

  override get_paginated_data = (
    page_index: number,
    page_size: number,
    filters: IFilters[]
  ) => {
    let data = new BehaviorSubject<IAccountReceiptDto[]>([]);
    let count = new BehaviorSubject<number>(0);
    let filter_values: Record<string, any> = {};
    filters.forEach((f) => {
      filter_values[f.id] = f.value === null ? undefined : f.value;
    });
    this.child_client
      .getAllAccountReceipts(
        page_index,
        page_size,
        JSON.stringify(filter_values)
      )
      .subscribe({
        error: (e) => {
          PrettyConsole.ERROR(
            `Error while getting the paypal receipts of all time, page: ${page_index}, size: ${page_size}: ${e}`
          );
        },
        next: (d) => {
          if (d.count) count.next(d.count);
          if (d.receipts) data.next(d.receipts);
        },
      });
    return { count: count.asObservable(), data: data.asObservable() };
  };

  lookup_permanent = () => {
    PrettyConsole.INFO('opening Account window');
    const loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
    const ds = new PermanentAccountReceipts();
    this.child_client
      .getAccountReceiptsOfToday(GetAccountReceiptsOfTodayQuery.fromJS({}))
      .subscribe({
        next: (receipts) => {
          ds.setData(receipts);
          loading$.next(false);
        },
        error: (err) => {
          PrettyConsole.ERROR(
            `getAccountReceiptsOfToday got error on subscribe ${err}`
          );
          loading$.next(false);
        },
      });

    this.dialog.open(PermanentTableComponent<PermanentAccountReceipts>, {
      width: '85vw',
      height: '80vh',
      data: {
        title: 'Account Receipts Of Today',
        receipts: ds,
        display: Object.keys(AccountReceiptDto.prototype.toJSON()).filter(
          (d) => d !== 'id'
        ),
        loading$,
        callback: () => {},
      },
    });
  };
}

export class PermanentAccountReceipts extends DataSource<IAccountReceiptDto> {
  data = new BehaviorSubject<IAccountReceiptDto[]>([]);

  connect(): Observable<IAccountReceiptDto[]> {
    return this.data.asObservable();
  }
  disconnect(): void {}

  addRow(row: IAccountReceiptDto) {
    const current = this.data.getValue();
    this.data.next([...current, row]);
  }

  setData(rows: AccountReceiptDto[]) {
    const data = rows.map((r) => r.toJSON());
    this.data.next(data);
  }
}
